import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import jsonConfig from 'src/assets/app-config.json';
import { LivechatAVLibrarySettings } from 'src/libs/livechat_ref.js';

LivechatAVLibrarySettings.LiveChatAvEnableReporting = true;

if (environment.production) {
  enableProdMode();
}


if (jsonConfig.enableConsole === false){
   if (window){
    window.console.log = () => { };
  }
}

platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.error(err));

